export default __webpack_public_path__ + "static/media/moderator-path-icon.993bde35.svg";